import { motion, useReducedMotion } from "framer-motion";
import glv from "../utils/getLocalizedValue";
import "../style/liquidiq-insertions.css";

const publicUrl = process.env.PUBLIC_URL || "";

function TechnologyLiquidIQSection() {
  const reduceMotion = useReducedMotion();
  const enter = (x = 0, y = 20, delay = 0) =>
    reduceMotion
      ? { initial: false }
      : {
          initial: { opacity: 0, x, y },
          whileInView: { opacity: 1, x: 0, y: 0 },
          viewport: { once: true, amount: 0.2 },
          transition: {
            duration: 0.75,
            delay,
            ease: [0.22, 1, 0.36, 1],
          },
        };

  return (
    <section
      className="liquidiq-technology font-pretendard"
      aria-labelledby="technology-liquidiq-title"
    >
      <div className="liquidiq-technology__inner">
        <div className="liquidiq-technology__lead">
          <motion.div className="liquidiq-technology__copy" {...enter(-24, 0)}>
            <p className="liquidiq-insertion-eyebrow">
              {glv("LiquidIQ and IMMC", "LiquidIQ와 IMMC")}
            </p>
            <h2
              id="technology-liquidiq-title"
              className="liquidiq-technology__title"
            >
              {glv(
                "The system changes when cooling starts at the chip.",
                "칩에서 시작하는 냉각은 시스템 전체를 바꿉니다."
              )}
            </h2>
            <p className="liquidiq-technology__description">
              {glv(
                "LiquidIQ shows what IMMC makes possible at system scale. Cooling at the package shortens the path from the heat source to the coolant, reducing dependence on bulky air cooling.",
                "LiquidIQ는 IMMC 기술이 시스템 전체에서 무엇을 가능하게 하는지 보여줍니다. 패키지에서 직접 냉각해 열원과 냉각수 사이의 경로를 줄이고 큰 공랭 구조에 대한 의존도를 낮춥니다."
              )}
            </p>
          </motion.div>

          <motion.figure
            className="liquidiq-technology__figure"
            {...enter(34, 0, 0.08)}
          >
            <img
              className="liquidiq-technology__image"
              src={`${publicUrl}/images/liquidiq/close-up-side-hq.png`}
              loading="lazy"
              decoding="async"
              alt={glv(
                "IMMC cooling hardware inside LiquidIQ",
                "LiquidIQ 내부의 IMMC 냉각 하드웨어"
              )}
            />
            <figcaption className="liquidiq-technology__caption">
              {glv(
                "IMMC cooling hardware inside LiquidIQ",
                "LiquidIQ 내부의 IMMC 냉각 하드웨어"
              )}
            </figcaption>
          </motion.figure>
        </div>

        <motion.div
          className="liquidiq-technology__stories"
          {...enter(0, 28, 0.06)}
        >
          <article className="liquidiq-technology__story">
            <p className="liquidiq-technology__story-number">01</p>
            <h3>{glv("Shorter path. Lower effort.", "더 짧은 경로. 더 적은 동력.")}</h3>
            <p>
              {glv(
                "The IMMC manifold feeds coolant through many short parallel microchannels. This helps move heat efficiently while reducing resistance inside the cooling loop.",
                "IMMC 매니폴드는 냉각수를 여러 개의 짧은 병렬 마이크로채널로 전달합니다. 냉각 루프 내부의 저항을 줄이면서 열을 효율적으로 이동시키는 구조입니다."
              )}
            </p>
          </article>

          <article className="liquidiq-technology__story">
            <p className="liquidiq-technology__story-number">02</p>
            <h3>{glv("Cooling that follows the work.", "작업에 맞춰 움직이는 냉각.")}</h3>
            <p>
              {glv(
                "LiquidIQ monitors temperature, flow, pressure and power, then adjusts coolant flow, inlet temperature and fan speed. This can reduce wasted cooling energy and its environmental impact when the workload is lighter while maintaining stable performance.",
                "LiquidIQ는 온도, 유량, 압력과 전력을 확인하고 냉각수 유량, 입구 온도와 팬 속도를 조절합니다. 작업량이 적을 때 불필요한 냉각 에너지와 환경 영향을 줄이면서 안정적인 성능을 유지할 수 있습니다."
              )}
            </p>
            <p className="liquidiq-technology__note">
              {glv(
                "Performance and energy results depend on system configuration and workload.",
                "성능과 에너지 결과는 시스템 구성과 작업 환경에 따라 달라질 수 있습니다."
              )}
            </p>
          </article>
        </motion.div>
      </div>
    </section>
  );
}

export default TechnologyLiquidIQSection;
